import classnames from 'classnames';
import React, {CSSProperties} from 'react';
import {WithTranslation, withTranslation} from 'react-i18next';
import {BlankSeparator} from '../component/BlankSeparator';
import {falseSupplier} from '../utils/functionUtils';
import {FeedbackDTO, Offset} from "../application/model";
import {services} from "../application/service/services";
import {FieldValue} from "../application/model/field/FieldValue";


interface InnerFeedbackComponentProps extends WithTranslation {
    feedback: FeedbackDTO,
    shouldHighlight?: (offset: Offset, selection?) => boolean,
    onClick?: () => void,
    centerOnOffset?: boolean,
    header?: JSX.Element | string,
    style?: CSSProperties,
    className?: string,
    verbatimStyle?: CSSProperties,
    verbatimClassName?: string,
    separatorHeight: number,
    innerRef?: any,
    display:FeedbackDisplay,
}
export enum FeedbackDisplay {
    SMALL,
    STANDARD
}


class InnerFeedbackComponent extends React.PureComponent<InnerFeedbackComponentProps> {

    verbatimRef = [];

    static defaultProps: Partial<InnerFeedbackComponentProps> = {
        shouldHighlight: falseSupplier,
        centerOnOffset: false
    };

    componentDidMount() {
        if (this.props.innerRef) this.props.innerRef.current = this;
    }

    filterOffsets(offsets) {
        const {shouldHighlight} = this.props;

        return (offsets || []).filter(offset => shouldHighlight(offset));
    }

    scrollToFirstVerbatimMatchingItem(newItems: Array<FieldValue>) {
        const verbatimsWithTopic = this.verbatimRef
            .filter(value => (value.verbatim.offsets || []).filter(offset => this.props.shouldHighlight(offset, newItems)).length > 0);
        if (verbatimsWithTopic.length > 0)
            verbatimsWithTopic[0].ref.current.scrollIntoView();
    }

    render() {
        this.verbatimRef = [];
        const {
            onClick,
            centerOnOffset,
            header,
            style,
            className,
            verbatimStyle,
            verbatimClassName,
            separatorHeight,
            feedback,
            shouldHighlight,
            display,
            t
        } = this.props;

        return <div className={classnames('vui-layout--vertical', className)} style={style} onClick={onClick}>
            {header}
            <BlankSeparator size={separatorHeight} vertical={true}/>
            <div className={classnames(verbatimClassName)} style={verbatimStyle}>
                {
                    services.getFeedbackService().getChannelKind(feedback).renderer(display, feedback, this.verbatimRef, t, centerOnOffset, shouldHighlight)
                }
            </div>
        </div>;
    }
}

export const InnerFeedback = withTranslation()(InnerFeedbackComponent);
